import React from 'react';
import { Link } from 'react-router-dom';
// import Testimonials from './HomeComp/Testimonials'
import NavBar from './common/NavBar';
import Photos from './HomeComp/Photos';
import Footer from './common/Footer';
import AboutUs from './HomeComp/AboutUs';
import OurHead from './HomeComp/OurHead';
import WhyChooseUs from './HomeComp/WhyChooseUs';

const Home = () => {
  return (
    <>
      <div className=' flex-auto '>
        <NavBar />
        <Photos />
        {/* <Link to="/mpd">Mpd </Link> */}
        {/* <Testimonials/> */}
       <AboutUs/>
       <WhyChooseUs/>
       <OurHead/>
      </div>
      
      <Footer/>
    </>
  );
}

export default Home;
